var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_setup.isPasswordSettingActive)?_c(_setup.PasswordSettingPageDemo):_c(_setup.PasswordSettingPage)
}
var staticRenderFns = []

export { render, staticRenderFns }